import { useEffect, useRef } from 'react';
import { applyResolvedUrlsToDoc, collectDocImageFileIds } from '@odo/shared-ui';
import type { TiptapDoc } from '@odo/shared-ui';
import { resolveProductImageUrls } from '../../../services/productImages';

// Inline images are fileIds and need signed URLs to render. Resolved once per
// product - re-running on a refetch or remount would overwrite in-progress edits.
export function useResolvedCopyDoc(
    productId: string | null,
    storedCopyDoc: TiptapDoc | null,
    onResolved: (doc: TiptapDoc) => void
) {
    const latest = useRef({ storedCopyDoc, onResolved });

    useEffect(() => {
        latest.current = { storedCopyDoc, onResolved };
    });

    useEffect(() => {
        const { storedCopyDoc: doc, onResolved: apply } = latest.current;
        if (!doc) return;
        const fileIds = collectDocImageFileIds(doc);
        if (fileIds.length === 0) return;

        let cancelled = false;
        resolveProductImageUrls(fileIds)
            .then((urls) => {
                if (!cancelled) apply(applyResolvedUrlsToDoc(doc, urls));
            })
            .catch(() => {
                /* leave unresolved - text stays intact, images may render broken */
            });
        return () => {
            cancelled = true;
        };
    }, [productId]);
}
